import { AudienceSelection } from './AudienceSelection';
import { AudienceProvider } from './context';

export const AudienceTakeover = () => {
  return (
    <AudienceProvider>
      <AudienceSelection />
    </AudienceProvider>
  );
};
